<template>
    <div>
        <base-header class="header d-flex align-items-center"
                     style="min-height: 400px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <h1 class="display-2 text-white">Hola Usuario</h1>
                        <p class="text-white mt-0 mb-5">Esta es tu pagina de perfil, aqui podras encontrar la
                            informacion relacionada con tu cuenta</p>

                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img src="img/theme/team-4-800x800.png" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <!--                  <base-button size="sm" type="info" class="mr-4">Connect</base-button>
                                                  <base-button size="sm" type="default" class="float-right">Message</base-button>-->
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <!--                                        <div>
                                                                                    <span class="heading">22</span>
                                                                                    <span class="description">Friends</span>
                                                                                </div>
                                                                                <div>
                                                                                    <span class="heading">10</span>
                                                                                    <span class="description">Photos</span>
                                                                                </div>
                                                                                <div>
                                                                                    <span class="heading">89</span>
                                                                                    <span class="description">Comments</span>
                                                                                </div>-->
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                    {{user.name}}
                                </h3>
                                <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Medellin, Colombia
                                </div>
                                <div class="h5 mt-4">
                                    {{user.user_type_id.user_type_name}}
                                </div>
                                <div>

                                        <span v-for="(res, index) in user.restaurant" :key="index">
                                            {{res.name}}<br>
                                        </span>


                                </div>
                                <hr class="my-4"/>
                                <!--   <a href="#">Show more</a>-->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Mi cuenta</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <!-- <a href="#!" class="btn btn-sm btn-primary">Guardar</a>-->
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Informacion de usuario</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Usuario"
                                                        placeholder="Username"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.user_login"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Email"
                                                        placeholder="jesse@example.com"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.email"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nombre"
                                                        placeholder="First name"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.name"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Apellidos"
                                                        placeholder="Last name"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.last_name"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4"/>
                                <!-- Address -->
                                <!--                                <h6 class="heading-small text-muted mb-4">Contact information</h6>
                                                                <div class="pl-lg-4">
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <base-input alternative=""
                                                                                        label="Address"
                                                                                        placeholder="Home Address"
                                                                                        input-classes="form-control-alternative"
                                                                                        v-model="model.address"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-4">
                                                                            <base-input alternative=""
                                                                                        label="City"
                                                                                        placeholder="City"
                                                                                        input-classes="form-control-alternative"
                                                                                        v-model="model.city"
                                                                            />
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <base-input alternative=""
                                                                                        label="Country"
                                                                                        placeholder="Country"
                                                                                        input-classes="form-control-alternative"
                                                                                        v-model="model.country"
                                                                            />
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <base-input alternative=""
                                                                                        label="Postal code"
                                                                                        placeholder="Postal code"
                                                                                        input-classes="form-control-alternative"
                                                                                        v-model="model.zipCode"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr class="my-4" />-->
                                <!-- Description -->
                                <!--                                <h6 class="heading-small text-muted mb-4">About me</h6>
                                                                <div class="pl-lg-4">
                                                                    <div class="form-group">
                                                                        <base-input alternative=""
                                                                                    label="About Me">
                                                                            <textarea rows="4" class="form-control form-control-alternative" placeholder="A few words about you ...">A beautiful Dashboard for Bootstrap 4. It is Free and Open Source.</textarea>
                                                                        </base-input>
                                                                    </div>
                                                                </div>-->
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'user-profile',
        data() {
            return {
                user: {},
                model: {
                    username: '',
                    email: '',
                    firstName: '',
                    lastName: '',
                    address: '',
                    city: '',
                    country: '',
                    zipCode: '',
                    about: '',
                }
            }
        },
        created() {

            this.user = JSON.parse(sessionStorage.getItem('user'))
        }
    };
</script>
<style></style>
